import { useEffect, useState } from 'react';
// apis
import { getClientsWithDisabledPos } from 'api';
// components
import { ExMultiSelectionWithApply } from '@commons/EXComponentsLibrary';

export const DropdownClientFilter = ({ setClientIdFilter, handleFetch, resetClientFilter }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [data, setData] = useState<any>([]);
    const key = 'clientFilter';

    useEffect(() => {
        if (data.length === 0) {
            setIsLoading(true);
            getClientsWithDisabledPos()
                .then((response) => setData(response.data.data))
                .catch((e) => console.error(e))
                .finally(() => setIsLoading(false));
        }
    }, []);

    return (
        <ExMultiSelectionWithApply
            key={key}
            data={data}
            handleApply={handleFetch}
            isLoading={isLoading}
            handleSetter={(value, item) => setClientIdFilter((prev) => value)}
            handleClean={resetClientFilter}
            searchPlaceholder={'Busca por cliente'}
            height={40}
            width={340}
            menuMaxHeight={228}
            valueKey={'id'}
            labelKey={'name'}
        />
    );
};
